import { Table } from 'antd';
import styled, { StyledComponent } from 'styled-components';

export const headerPaddingTop = 16;
export const headerPaddingBottom = 12;

export const TableViewContainer = styled.div`
  background-color: #f7fafc;
  padding-left: 2rem;
  padding-right: 2rem;
  overflow: hidden;
  min-height: 100vh;
`;

// Ant Design's Table component is generic; styled-components cannot preserve that generic across consumers.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const StyledTable = styled(Table)<StyledComponent<any, any>>`
  .ant-table-title {
    background-color: #f7fafc;
    background-clip: 'padding-box';
    border: none !important;
    padding: ${(props) => (props.padding ? props.padding : '0px 0px 0px 0px')};
  }

  .ant-table-container {
    border-color: #ebf5ff !important;
  }

  .ant-table-body::-webkit-scrollbar {
    width: 6px;
  }

  .ant-table-body::-webkit-scrollbar-track {
    background: #f7fafc;
  }

  .ant-table-body::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
  }

  .ant-table-header {
    box-shadow: 1px 3px 4px 0px rgba(226, 236, 244, 1);
    -webkit-box-shadow: 1px 3px 4px 0px rgba(226, 236, 244, 1);
    -moz-box-shadow: 1px 3px 4px 0px rgba(226, 236, 244, 1);
  }

  .ant-table-thead .ant-table-cell {
    background-color: white;
  }

  .ant-table-row:hover td {
    background-color: #f2f8fe !important;
  }

  .ant-table-row-selected td {
    background-color: #f2f8fe !important;
  }

  .ant-table-cell {
    border-color: #ebf5ff !important;
  }

  .ant-pagination-item-active {
    border: none;
    background: transparent linear-gradient(21deg, #0130f8 0%, #5eecfc 77%, #ffffff 100%) 0% 0% no-repeat padding-box;

    a {
      color: white;
    }
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const StyledLinkedTable = styled(StyledTable)<StyledComponent<any, any>>`
  .ant-table-body .ant-table-cell {
    padding: 0px;
  }
`;
